import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';

export default class StateButton extends Phaser.GameObjects.Container {
  /**
     * 
     * @param {Phaser.Scene} scene 
     */
  constructor(scene, sprite1, sprite2) {
    super(scene);

    this.enabled = true;
    this.state = 0;
    this.buttonSprite1 = ABCyaPhaser.Images.addImage(0, 0, sprite1, this).setOrigin(0.5);
    this.buttonSprite2 = ABCyaPhaser.Images.addImage(0, 0, sprite2, this).setOrigin(0.5);
    this.buttonSprite2.alpha = 0;

    ABCyaPhaser.Container.setContainerInteractive(this, false);

    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick, this);
  }

  doClick(evt) {
    if (!this.enabled) { return; }

    if (this.state === 0) {
      this.buttonSprite2.alpha = 1;
      this.buttonSprite1.alpha = 0;
      this.state = 1;

      this.doAction1(evt);
    }
    else {
      this.buttonSprite2.alpha = 0;
      this.buttonSprite1.alpha = 1;
      this.state = 0;
      this.doAction2(evt);
    }

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    ABCyaPhaser.Tweens.addTween(this, 70, { scale: 0.8, yoyo: true }, Phaser.Math.Easing.Quadratic.Out);
  }

  switchStateOff() {
    this.state = 1;
    this.buttonSprite2.alpha = 1;
    this.buttonSprite1.alpha = 0;
  }
}